import { nanoid } from 'nanoid';
import { getDB } from '../storage/db';
import { sortByDateDesc } from '../utils/sort';
export async function list() {
    const db = await getDB();
    const readings = await db.getAll('saltLevels');
    return sortByDateDesc(readings);
}
export async function latest() {
    const all = await list();
    return all.length > 0 ? all[0] : null;
}
export async function report(percentage, date) {
    if (!Number.isFinite(percentage) || percentage < 0 || percentage > 100) {
        throw new Error('Salt level must be between 0 and 100');
    }
    const now = new Date();
    const reading = {
        id: nanoid(),
        percentage,
        date: date ?? now.toISOString().slice(0, 10),
        createdAt: now.toISOString(),
    };
    const db = await getDB();
    await db.put('saltLevels', reading);
    return reading;
}
export async function remove(id) {
    const db = await getDB();
    await db.delete('saltLevels', id);
}
export async function clearAll() {
    const db = await getDB();
    await db.clear('saltLevels');
}
